import type { RouteObject } from "react-router";

import { ErrorPage } from "@/components/Error/ErrorPage";
import { RequireAuth } from "@/components/Routing/RequireAuth";

import { canListAutomatedSurveys, canManageAutomatedSurveys } from "./permissions";
import { automatedSurveysRoutes } from "./routes";

export const automatedSurveysRoute = [
  {
    path: automatedSurveysRoutes.list,
    lazy: async () => {
      const { ListAutomatedSurveysPage } = await import("./pages/list/ListAutomatedSurveysPage");

      return {
        element: (
          <RequireAuth permission={canListAutomatedSurveys}>
            <ListAutomatedSurveysPage />
          </RequireAuth>
        ),
      };
    },
  },
  {
    path: automatedSurveysRoutes.create,
    lazy: async () => {
      const { CreateAutomatedSurveyPage } = await import("./pages/create-or-edit/CreateAutomatedSurveyPage");

      return {
        element: (
          <RequireAuth permission={canManageAutomatedSurveys}>
            <CreateAutomatedSurveyPage />
          </RequireAuth>
        ),
      };
    },
  },
  {
    path: automatedSurveysRoutes.edit,
    lazy: async () => {
      const { EditAutomatedSurveyPage } = await import("./pages/create-or-edit/EditAutomatedSurveyPage");

      return {
        element: (
          <RequireAuth permission={canManageAutomatedSurveys}>
            <EditAutomatedSurveyPage />
          </RequireAuth>
        ),
      };
    },
  },
  {
    path: automatedSurveysRoutes.details,
    lazy: async () => {
      const { ActiveSurveyDetailsPage } = await import("./pages/active-survey-details/ActiveSurveyDetailsPage");

      return {
        element: (
          <RequireAuth permission={canListAutomatedSurveys}>
            <ActiveSurveyDetailsPage />
          </RequireAuth>
        ),
      };
    },
  },
  { path: "*", element: <ErrorPage status={404} /> },
] satisfies RouteObject[];
